import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { useTranslation } from 'react-i18next';
import { cookieConsentConfig } from '../lib/cookieconsent-config';

export const CookieConsentInit = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const activeLang = i18n.resolvedLanguage || i18n.language || 'de';
    const configWithActiveLang = {
      ...cookieConsentConfig,
      language: {
        ...cookieConsentConfig.language,
        default: activeLang
      }
    };

    CookieConsent.run(configWithActiveLang);
  }, []);

  useEffect(() => {
    const lang = i18n.resolvedLanguage || i18n.language || 'de';
    if (cookieConsentConfig.language.translations[lang]) {
      CookieConsent.setLanguage(lang).catch(() => {
        // Ignored if run() has not finished initializing yet
      });
    }
  }, [i18n.language, i18n.resolvedLanguage]);

  return null;
};
